import { Route } from "react-router-dom";
import ProviderDashboard from "../components/provider_panel_dashboard";
import ProviderPanelInfo from "../components/provider_info";
import ProviderPanelImage from "../components/provider_image";
import ProviderPanelService from "../components/provider_service";
import ProviderPanelVideo from "../components/provider_video";
import ProviderPanelAppointment from "../components/provider_appointment";
import ProviderPanelWorkTime from "../components/provider_worktime";
import ProviderPanelPayment from "../components/provider_payment_setting";
import ProviderRateReview from "../components/provider_rate_review";
import ProviderPlans from "../components/provider_plan";
import ProviderPaymentSuccess from "../components/provider_payment_success";
import ProviderPaymentSent from "../components/provider_payment_sent";
import ProviderVerify from "../components/provider_verify";
import ProviderPanelStripeSetting from "../components/provider_stripe_setting";
import ProviderPanelDashboard from "../components/provider_dashboard";

import ProviderMiddleware from "../../provider-middleware/components/index";

const ProviderPanelRoutes = () => (
  <>
    <Route path="panel" element={<ProviderMiddleware><ProviderDashboard /></ProviderMiddleware>}>
      <Route index element={<ProviderPanelInfo />} /> 
      <Route path="info" element={<ProviderPanelInfo />} />
      <Route path="image" element={<ProviderPanelImage />} />
      <Route path="service" element={<ProviderPanelService />} />
      <Route path="video" element={<ProviderPanelVideo />} />
      <Route path="appointment" element={<ProviderPanelAppointment />} />
      <Route path="worktime" element={<ProviderPanelWorkTime />} />
      <Route path="payment" element={<ProviderPanelPayment />} />
      <Route path="rate-review" element={<ProviderRateReview />} />
      <Route path="plans" element={<ProviderPlans />} />
      <Route path="payment-success" element={<ProviderPaymentSuccess />} />
      <Route path="payment-sent" element={<ProviderPaymentSent />} />
      <Route path="verify" element={<ProviderVerify />} />
      <Route path="stripe-setting" element={<ProviderPanelStripeSetting />} />
      <Route path="dashboard" element={<ProviderPanelDashboard />} />
    </Route>
  </>
);


export default ProviderPanelRoutes;
